import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  taskList: [],
  taskDetail: [],
  loading: false,
  error: undefined,
};

const taskSlice = createSlice({
  name: "task",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchTaskList(state, action) {
      state.taskList = action.payload;
      state.loading = false;
    },
    fetchTaskDetail(state, action) {
      state.taskDetail = action.payload;
      state.loading = false;
    },
  },
});

export const taskActions = taskSlice.actions;

export default taskSlice.reducer;
